import { WorkflowTemplateStatus } from '../Types'

const sales: WorkflowTemplateStatus = {
  configuration: {
    'c8a1feab-d2f6-421a-952d-99a57e65c6d4': {
      exit: [],
      entry: [],
    },
    'b017bb16-9488-4798-85d8-b6f88e6fab79': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'reviews.create',
          config: {},
        },
      ],
    },
    '75eb0991-5278-4a67-b98f-f8bb654e7fb9': {
      exit: [],
      entry: [],
    },
    'e714f559-4022-42cd-a9c0-c8c80d190ac2': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'approvals.create',
          config: {},
        },
      ],
    },
    '279f6a5d-591e-4c29-b658-cd8733373a35': {
      exit: [],
      entry: [],
    },
    '834c999c-2ab4-4097-bb7f-34000143d681': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'approvals.create',
          config: {},
        },
      ],
    },
    '4b74ea09-763f-41f4-b158-531419411380': {
      exit: [],
      entry: [],
    },
    '505303af-8533-4d42-9bf8-7b200c4952e9': {
      exit: [],
      entry: [
        {
          type: 'files.export',
          config: {},
        },
      ],
    },
    '05f8ebc5-4d74-4b1b-bd72-2c2e81e43d3f': {
      exit: [],
      entry: [],
    },
    '65cb0cfb-9779-4fca-8ead-c3816388403f': {
      exit: [],
      entry: [],
    },
    '4872e8ef-c1dc-4c69-9377-ec096d0ef6c2': {
      exit: [],
      entry: [],
    },
  },
  property_values: [
    {
      uuid: 'c8a1feab-d2f6-421a-952d-99a57e65c6d4',
      value: 'Draft',
      meta: {
        color: '#B1BECD',
      },
      position: 0,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: 'b017bb16-9488-4798-85d8-b6f88e6fab79',
      value: 'Legal Review',
      meta: {
        color: '#C698FF',
      },
      position: 1,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '75eb0991-5278-4a67-b98f-f8bb654e7fb9',
      value: 'Legal Reviewed',
      meta: {
        color: '#5500BF',
      },
      position: 2,
      connected_to_uuid: 'b017bb16-9488-4798-85d8-b6f88e6fab79',
      connected_to_id: null,
    },
    {
      uuid: 'e714f559-4022-42cd-a9c0-c8c80d190ac2',
      value: 'Finance Approval',
      meta: {
        color: '#FFEFC5',
      },
      position: 3,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '279f6a5d-591e-4c29-b658-cd8733373a35',
      value: 'Finance Approved',
      meta: {
        color: '#F3A100',
      },
      position: 4,
      connected_to_uuid: 'e714f559-4022-42cd-a9c0-c8c80d190ac2',
      connected_to_id: null,
    },
    {
      uuid: '834c999c-2ab4-4097-bb7f-34000143d681',
      value: 'Client Approval',
      meta: {
        color: '#FFD6F9',
      },
      position: 5,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '4b74ea09-763f-41f4-b158-531419411380',
      value: 'Client Approved',
      meta: {
        color: '#E43CD5',
      },
      position: 6,
      connected_to_uuid: '834c999c-2ab4-4097-bb7f-34000143d681',
      connected_to_id: null,
    },
    {
      uuid: '505303af-8533-4d42-9bf8-7b200c4952e9',
      value: 'Read',
      meta: {
        color: '#DAE6FF',
      },
      position: 7,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '65cb0cfb-9779-4fca-8ead-c3816388403f',
      value: 'Signed',
      meta: {
        color: '#0026AD',
      },
      position: 7,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '4872e8ef-c1dc-4c69-9377-ec096d0ef6c2',
      value: 'Final',
      meta: {
        color: '#028C3A',
      },
      position: 7,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '05f8ebc5-4d74-4b1b-bd72-2c2e81e43d3f',
      value: 'Deprecated',
      meta: {
        color: '#FFCBCB',
      },
      position: 8,
      connected_to_uuid: null,
      connected_to_id: null,
    },
  ],
}

export default sales
